import { Component } from '@angular/core';
import { ClientTheme, CLIENT_THEME } from 'src/app/features/client';

@Component({
    selector: 'app-header-slim',
    templateUrl: './header-slim.component.html',
    styleUrls: ['./header-slim.component.scss'],
    standalone: false
})
export class HeaderSlimComponent {
  clientTheme: ClientTheme;

  constructor() {
    this.clientTheme = CLIENT_THEME
  }


}
